import { render, staticRenderFns } from "./FloorPhysicsAssociationEdit.vue?vue&type=template&id=33599f98&"
import script from "./FloorPhysicsAssociationEdit.vue?vue&type=script&lang=js&"
export * from "./FloorPhysicsAssociationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports